import React from 'react';
import Notif from './Notif';
import PropTypes from 'prop-types';
import {TransitionGroup} from "react-transition-group";
import {useDispatch, useSelector} from "react-redux";
import {notifsActions} from "../../../actions";

// This checks to see if object is immutable and properly access it
const getter = (obj, propName) => (obj.get ? obj.get(propName) : obj[propName]);

const Notifs = (props) => {

    const dispatch = useDispatch();

    const [state, setState] = React.useState([]);
    const notifications = useSelector(state => state.notifs);
    const notifDismiss = React.useCallback((id) => dispatch(notifsActions.notifDismiss(id)), [dispatch]);

    React.useEffect(() => {
        let __notifications = [...notifications]
            .map(x => Object.assign({}, x))
            .map(x => {
                if (!x.setTimeout && x.isOpen) {
                    x.setTimeout = true;
                    setTimeout(() => notifDismiss(x.id), x.dismissAfter);
                }
                return x;
            });

        setState(__notifications);

    }, [notifications, notifDismiss])


    const toggle = (id) => {
        notifDismiss(id);
    };

    const renderedNotifications = () => {
        const {
            componentClassName,
            CustomComponent
        } = props;

        return state.map((notification) => {
            if (CustomComponent) {
                return (
                    <CustomComponent
                        {...props}
                        componentClassName={componentClassName}
                        key={getter(notification, 'id')}
                        id={getter(notification, 'id')}
                        message={getter(notification, 'message')}
                        type={getter(notification, 'type')}
                    />
                );
            }
            return (
                <Notif key={getter(notification, 'id')}
                       {...props}
                       componentClassName={componentClassName}
                       id={getter(notification, 'id')}
                       message={getter(notification, 'message')}
                       type={getter(notification, 'type')}
                       isOpen={notification.isOpen}
                       toggle={(id) => toggle(id)}
                />
            );
        });
    };

    // render() {
    return (
        <TransitionGroup className='p-3'>
            {renderedNotifications()}
        </TransitionGroup>

    );
};

Notifs.defaultProps = {
    className: null,
    componentClassName: 'notif',
    CustomComponent: null,
    transitionEnterTimeout: 800,
    transitionLeaveTimeout: 800,
};

Notifs.propTypes = {
    notifications: PropTypes.array,
    className: PropTypes.string,
    CustomComponent: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.node,
        PropTypes.element,
    ]),
    componentClassName: PropTypes.string,
    transitionEnterTimeout: PropTypes.number,
    transitionLeaveTimeout: PropTypes.number,
};

export default Notifs;

